// extracted by mini-css-extract-plugin
var _1 = "_productSettingDetailsForm-module__container";
var _2 = "_productSettingDetailsForm-module__danger";
var _3 = "_productSettingDetailsForm-module__edit-button";
var _4 = "_productSettingDetailsForm-module__flex-div";
var _5 = "_productSettingDetailsForm-module__flex-span-container";
var _6 = "_productSettingDetailsForm-module__form-container";
var _7 = "_productSettingDetailsForm-module__form-subcontainer";
var _8 = "_productSettingDetailsForm-module__round";
var _9 = "_productSettingDetailsForm-module__slider";
var _a = "_productSettingDetailsForm-module__submit-button";
var _b = "_productSettingDetailsForm-module__switch";
export { _1 as "container", _2 as "danger", _3 as "edit-button", _4 as "flex-div", _5 as "flex-span-container", _6 as "form-container", _7 as "form-subcontainer", _8 as "round", _9 as "slider", _a as "submit-button", _b as "switch" }
